import React from "react";

function Footer() {
  return (
    <div className="flex bottom-0 bg-gradient-to-t from-sombe-400 to-sombe-300 text-white py-2 mt-2 justify-center items-center">
      <h3>Copyright&copy; All right reserverd. BrainGhost</h3>
    </div>
  );
}

export default Footer;
